import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [ministriesOpen, setMinistriesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
    setMinistriesOpen(false);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const ministries = [
    { to: '/mens-rehabilitation-center', label: "Men's Rehabilitation Center" },
    { to: '/orphanage-ministry', label: 'Orphanage Ministry' },
    { to: '/ministry-for-needy', label: 'Ministry for the Needy' },
    { to: '/ministry-for-homeless-people', label: 'Ministry for Homeless People' },
    { to: '/ministry-for-people-with-acute-infectious-diseases', label: 'Ministry for People with Acute Infectious Diseases' },
    { to: '/ministry-for-refugees', label: 'Ministry for Refugees' },
  ];

  return (
    <>
      {/* Navbar */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        {/* Top Bar */}
        <div className="navbar-top">
          <div className="container navbar-top-inner">
            <div className="navbar-phones">
              <span>US:</span>
              <a href="tel:+15596688807">+1 (559) 668-8807</a>
              <span>|</span>
              <span>Armenia:</span>
              <a href="tel:+37455677888">+374 55 677888</a>
            </div>
            <div className="navbar-socials">
              <a href="https://www.facebook.com/TeenChallengeArmenia/" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://www.youtube.com/@teenchallengearmenia852" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://www.instagram.com/teenchallengearmenia/" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://www.linkedin.com/company/teenchallengearmenia" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>

        {/* Main Nav */}
        <div className="container">
          <div className="navbar-main">
            <Link to="/" className="navbar-logo">
              <img
                src="/images/logo.png"
                alt="Teen Challenge Armenia Logo"
              />
            </Link>

            {/* Desktop Links */}
            <ul className="navbar-links">
              <li><Link to="/">Home</Link></li>
              <li className="dropdown">
                <button>Ministries ▾</button>
                <div className="dropdown-menu">
                  {ministries.map(m => (
                    <Link key={m.to} to={m.to}>{m.label}</Link>
                  ))}
                </div>
              </li>
              <li><Link to="/testimonies">Testimony</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/donate" className="donate-btn">Donate</Link></li>
            </ul>

            {/* Mobile Toggle */}
            <button
              className={`mobile-toggle ${mobileOpen ? 'open' : ''}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Nav — rendered OUTSIDE <nav> to avoid backdrop-filter containing block bug */}
      <div className={`mobile-nav ${mobileOpen ? 'open' : ''}`}>
        <button
          className="mobile-nav-close"
          onClick={() => setMobileOpen(false)}
          aria-label="Close menu"
        >
          ✕
        </button>
        <Link to="/">Home</Link>
        <button
          className="mobile-nav-accordion"
          onClick={() => setMinistriesOpen(!ministriesOpen)}
        >
          Ministries {ministriesOpen ? '▴' : '▾'}
        </button>
        {ministriesOpen && (
          <div className="mobile-sub">
            {ministries.map(m => (
              <Link key={m.to} to={m.to}>{m.label}</Link>
            ))}
          </div>
        )}
        <Link to="/testimonies">Testimony</Link>
        <Link to="/about">About Us</Link>
        <Link to="/gallery">Gallery</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/donate" className="mobile-donate-btn">Donate</Link>
      </div>
    </>
  );
};

export default Navbar;
